<template>
  <rh-painel-acesso>
    <div v-if="concluido">
      <b-icon icon="check-circle-outline" size="is-large" class="rh-ok"></b-icon>
      <h1>Senha atualizada</h1>
      <p>Agora você pode entrar com sua nova senha.</p>
      <router-link to="/rh" class="button is-primary is-fullwidth">Ir para o login</router-link>
    </div>
    <div v-else>
      <p class="rh-kicker">ACESSO SEGURO</p>
      <h1>Definir nova senha</h1>
      <p>Use pelo menos 6 caracteres, com letras e números.</p>
      <b-message v-if="erro" type="is-danger">{{ erro }}</b-message
      ><ValidationObserver v-slot="{ handleSubmit }" slim
        ><form @submit.prevent="handleSubmit(salvar)">
          <ValidationProvider v-slot="{ errors }" name="Senha" rules="required|min:6" vid="nova"
            ><b-field label="Nova senha" :type="errors.length ? 'is-danger' : ''" :message="errors[0]"
              ><b-input
                v-model="senha"
                type="password"
                password-reveal
                autocomplete="new-password"
              ></b-input></b-field></ValidationProvider
          ><ValidationProvider v-slot="{ errors }" name="Confirmação" rules="required|confirmed:nova"
            ><b-field label="Confirmar senha" :type="errors.length ? 'is-danger' : ''" :message="errors[0]"
              ><b-input
                v-model="confirmacao"
                type="password"
                password-reveal
                autocomplete="new-password"
              ></b-input></b-field></ValidationProvider
          ><b-button type="is-primary" native-type="submit" expanded :loading="salvando" :disabled="!token"
            >Salvar senha</b-button
          >
        </form></ValidationObserver
      >
    </div>
  </rh-painel-acesso>
</template>
<script>
import http from '@/http'
import RhPainelAcesso from '@/components/rh_painel_acesso.vue'
export default {
  name: 'RhRedefinir',
  components: { RhPainelAcesso },
  data() {
    return { token: '', senha: '', confirmacao: '', erro: '', concluido: false, salvando: false }
  },
  created() {
    this.token = decodeURIComponent((this.$route.hash || '').replace(/^#/, ''))
    if (!this.token) this.erro = 'Link inválido. Solicite uma nova recuperação.'
    else history.replaceState(null, '', '/rh/redefinir')
  },
  methods: {
    async salvar() {
      if (!this.token || this.senha !== this.confirmacao) return
      this.salvando = true
      this.erro = ''
      try {
        await http.post('/api/rh/auth/redefinir', { token: this.token, senha: this.senha })
        this.concluido = true
        this.token = ''
        this.senha = ''
        this.confirmacao = ''
      } catch (e) {
        this.erro = e && e.data && e.data.erro ? e.data.erro : 'Não foi possível redefinir a senha.'
      } finally {
        this.salvando = false
      }
    },
  },
}
</script>
